<div class="header fx-row fx-justify-space-between fx-items-center">
	<div class="description fx-row fx-justify-start fx-items-center" style="gap: 12px">
		<span class="material-icons-outlined">fact_check</span>
		<span class="label">{{'Servizi' | translate}}</span>
	</div>

	<div class="close-icon fx-row fx-justify-end fx-items-center">
		<span class="material-icons-outlined dialog-close-icon" (click)="onCloseClick()">close</span>
	</div>
</div>

<div class="trip-booking-services-container">
	<dataset-list
		[elevate]='false'
		[showSearchBar]='false'
		[showCreateForm]='false'
		[enableCreate]='false'
		[showTitle]='false'
		datasetCode='trip_booking_services'
		[parentDatasetACS]='data.tripBookingPackageACS'
		[parentDatasetRS]='data.tripBookingPackageRS'
		[filters]='{ trip_booking_package_id: data.tripBookingPackage.id }'
		[enableActions]='data.bookingService.canEdit && !data.tripBookingPackage.trip_package.tourcms_channel_id_tour_id'
		[enableDelete]='data.bookingService.canEdit && !data.tripBookingPackage.trip_package.tourcms_channel_id_tour_id'
		[enableCreate]='data.bookingService.canEdit && !data.tripBookingPackage.trip_package.tourcms_channel_id_tour_id'
		[enableEdit]='data.bookingService.canEdit && !data.tripBookingPackage.trip_package.tourcms_channel_id_tour_id'
		tableStyle="style-3"
	></dataset-list>
</div>
<!-- footer -->
<div class="footer fx-row fx-justify-space-between fx-items-center">
	<div class="fx-row fx-justify-start fx-items-center" style="gap: 24px">
		<span class="label">{{'Totale' | translate}}:</span>
		<span class="value">{{ data.bookingStepService.datasetRS.record.value.total_amount | currency:"EUR" }}</span>
	</div>
	<div class="fx-row fx-justify-start fx-items-center">
		<button (click)="addTripBookingService()" class="add-service-btn fx-row fx-justify-center fx-items-center" style="gap: 8px">
			<span class="material-icons-outlined">add</span> 
			<span class="btn-label">{{'Aggiungi servizio' | translate}}</span>
		</button>
	</div>
</div>